import $ from "../jquery_global";

let productIndex = document.querySelectorAll('.product-fields').length;
let currentGroupHotels = [];

function autofillProductDescription() {
  $(document).off('input focus', '.product-description-autocomplete')
  .on('input focus', '.product-description-autocomplete', function () {
    const $input = $(this);
    const supplierDeliveryId = $input.data('supplier-delivery-id');
    const $wrapper = $input.closest('.product-autocomplete-wrapper');
    const $dropdown = $wrapper.find('.autocomplete-dropdown-results');

    clearTimeout($input.data('autocomplete-timer'));

    const timer = setTimeout(() => {
      const term = $input.val().trim();

      if (term.length < 3) {
        $dropdown.empty().addClass('d-none').removeClass('show');
        return;
      }

      $.ajax({
        url: `/admin/supplier_deliveries/${supplierDeliveryId}/product_name_autofill`,
        data: { term },
        success: function (data) {
          $dropdown.empty();

          if (!data || data.length === 0) {
            $dropdown.append('<div class="dropdown-item disabled">No results found</div>');
          } else {
            data.forEach(item => {
              $dropdown.append(`<a href="#" class="dropdown-item" data-value="${item.value}">${item.value}</a>`);
            });
          }

          $dropdown.removeClass('d-none').addClass('show');
        }
      });
    }, 300); // debounce

    $input.data('autocomplete-timer', timer);
  });

  // Select item
  $(document).off('click', '.autocomplete-dropdown-results .dropdown-item')
  .on('click', '.autocomplete-dropdown-results .dropdown-item', function (e) {
    e.preventDefault();
    const $item = $(this);
    const $wrapper = $item.closest('.product-autocomplete-wrapper');
    const $input = $wrapper.find('.product-description-autocomplete');
    const $dropdown = $wrapper.find('.autocomplete-dropdown-results');

    $input.val($item.data('value'));
    $dropdown.empty().addClass('d-none').removeClass('show');
  });

  // Hide dropdown when focus leaves the wrapper
  $(document).off('focusout', '.product-autocomplete-wrapper')
  .on('focusout', '.product-autocomplete-wrapper', function (e) {
    const $wrapper = $(this);
    const $dropdown = $wrapper.find('.autocomplete-dropdown-results');

    // Check if the new focused element is still inside the wrapper
    const isStillInside = $.contains($wrapper[0], e.relatedTarget);

    if (!isStillInside) {
      setTimeout(() => {
        $dropdown.empty().addClass('d-none').removeClass('show');
      }, 150);
    }
  });

  // Click outside
  $(document).off('click.autocomplete-outside').on('click.autocomplete-outside', function (e) {
    if (!$(e.target).closest('.product-autocomplete-wrapper').length) {
      $('.autocomplete-dropdown-results').empty().addClass('d-none').removeClass('show');
    }
  });

  // Prevent Enter key from submitting the form if dropdown is visible & close dropdown
  $(document).off('keydown', '.product-description-autocomplete')
  .on('keydown', '.product-description-autocomplete', function (e) {
    const $input = $(this);
    const $dropdown = $input.closest('.product-autocomplete-wrapper').find('.autocomplete-dropdown-results');

    const isDropdownVisible = $dropdown.hasClass('show') && !$dropdown.hasClass('d-none');

    if (e.key === 'Enter' && isDropdownVisible) {
      e.preventDefault(); // Stop form submission
      $dropdown.empty().addClass('d-none').removeClass('show'); // Close dropdown
    }
  });
}

function handleFaoProductList() {
  $(".supplier_delivered_product_fao_product_id").select2({
    minimumInputLength: 3,
    placeholder: "Select FAO Product",
    allowClear: true,
    ajax: {
      url: "/admin/supplier_deliveries/fao_products",
      dataType: 'json',
      delay: 300,
      type: "GET",
      processResults: function (data) {
        return {
          results: data.fao_products_list
        }
      }
    }
  })
}

function hotelOptionsHtml() {
  const options = ['<option value="">Select Property</option>'];

  currentGroupHotels.forEach((hotel) => {
    const text = hotel.text || hotel.name || '';
    options.push(`<option value="${hotel.id}">${text}</option>`);
  });

  return options.join('');
}

function refreshHotelSelects() {
  const options = hotelOptionsHtml();
  const hasHotels = currentGroupHotels.length > 0;

  $(".supplier-delivery-hotel-select").each(function () {
    const $select = $(this);
    const previousValue = $select.data("selectedHotelId") || $select.val();

    $select.html(options);

    const valueExists = currentGroupHotels.some(
      (hotel) => String(hotel.id) === String(previousValue)
    );

    if (valueExists) {
      $select.val(String(previousValue));
    } else {
      $select.val("");
    }

    $select.prop("disabled", !hasHotels);
  });
}

function fetchHotelsForGroup(groupId) {
  if (!groupId) {
    currentGroupHotels = [];
    refreshHotelSelects();
    return;
  }

  $.ajax({
    url: `/admin/groups/${groupId}/hotel_list`,
    dataType: "json",
    success: function (data) {
      currentGroupHotels = (data && data.hotels) || [];
      refreshHotelSelects();
    },
    error: function () {
      currentGroupHotels = [];
      refreshHotelSelects();
    },
  });
}

function initHotelDropdowns() {
  const $groupSelect = $("#supplier_delivery_group_id");
  if (!$groupSelect.length) {
    return;
  }

  $(".supplier-delivery-hotel-select").each(function () {
    const $select = $(this);
    if ($select.val()) {
      $select.data("selectedHotelId", $select.val());
    }
  });

  fetchHotelsForGroup($groupSelect.val());
}

function bindHotelDropdownEvents() {
  $(document)
    .off("change", "#supplier_delivery_group_id")
    .on("change", "#supplier_delivery_group_id", function () {
      fetchHotelsForGroup($(this).val());
    });

  $(document)
    .off("cocoon:after-insert", "#po-list")
    .on("cocoon:after-insert", "#po-list", function (event, insertedItem) {
      const $hotelSelect = $(insertedItem).find(".supplier-delivery-hotel-select");
      if ($hotelSelect.length) {
        $hotelSelect.data("selectedHotelId", "");
        refreshHotelSelects();
      }
    });
}

window.handleSupplierDeliveryClick = window.handleSupplierDeliveryClick || function (e) {
  if (e.target.classList.contains('remove-product')) {
    var container = e.target.closest('.product-fields');
    container.remove();
  } else if (e.target.id == 'add-product-btn') {
    var container = document.getElementById('products-container');
    var template = document.getElementById('blank-product-template');
    let newHTML = template.innerHTML.replace(/__INDEX__/g, productIndex);
    container.insertAdjacentHTML('beforeend', newHTML);
    productIndex++;
    autofillProductDescription();
    handleFaoProductList();
  } else if (e.target.id == 'back-step-btn') {
    fetch(e.target.dataset.url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    }).then(response => {
      if (response.redirected) {
        window.location.href = response.url;
      }
    });
  }
}

document.addEventListener('turbo:load', function () {
  document.removeEventListener('click', window.handleSupplierDeliveryClick);
  document.addEventListener('click', window.handleSupplierDeliveryClick);
  autofillProductDescription();
  handleFaoProductList();
  bindHotelDropdownEvents();
  initHotelDropdowns();
});
